// Standalone /chunk-tuning page. Reuses ChunkTuningGuide in "page" mode
// for a wider, longer-form layout. Linked from the inline "Open full
// guide" affordance in the Ingestion form's recommendations panel.

import React from "react";
import { COLORS } from "../../theme/colors";
import ChunkTuningGuide from "./ChunkTuningGuide";


export default function ChunkTuningDocs() {
  return (
    <div style={{
      flex: 1, overflow: "auto",
      background: COLORS.surface, padding: "40px 24px",
    }}>
      <ChunkTuningGuide variant="page" />
    </div>
  );
}
